import axios from "axios";
import { handleJWT, rmStorageAndReload } from "./handleJWT";

const SERVER_URL = `https://auth.umlang.com/auth`;
// const SERVER_URL = `http://localhost:4001/auth`;

// const sampleApi = (data,paginate) => {
//   let token = JSON.parse(localStorage.getItem("token"));
//   const url = `${SERVER_URL}/api/v1/marketing/referral/codes/getUserCodes?limit=${paginate.perPage || 10}&page=${paginate.page||1}`;
//   return axios.post(url, data, {
//     headers: {
//       Accept: "Application/json",
//       authorization: `bearer ${token}`,
//     },})
// };

const loginApi = (data) => {
  data["device"]="web"
  const url = `${SERVER_URL}/api/v1/auth/login/`;
  return axios.post(url, data);
};

const RegisterStepOneApi = async (data) => {
  let phoneCode = data["phoneNumber"].slice(0, 2)
  let userIp = null
  if (phoneCode !== "98") {
    let getIpUser = await fetch('https://api.ipify.org?format=json')
    let info = await getIpUser.json()
    userIp = info.ip
  }
  data["userIp"] = userIp
  const url = `${SERVER_URL}/api/v1/auth/register/step1`;
  return axios.post(url, data);
};
const RegisterStepTwoApi = (data) => {
  data["device"]="web"
  const url = `${SERVER_URL}/api/v1/auth/register/step2`;
  return axios.post(url, data);
};

const setPasswordApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/auth/register/step3`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await setPasswordApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const changePasswordApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/auth/register/changepassword`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await changePasswordApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

// این ای پی آی باید نوشته  شود
const setReferralCodeApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/auth/register/setReferralCode`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await setReferralCodeApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const loginCodeStep1Api = async (data) => {
  let phoneCode = data["phoneNumber"].slice(0, 2)
  let userIp = null
  if (phoneCode !== "98") {
    let getIpUser = await fetch('https://api.ipify.org?format=json')
    let info = await getIpUser.json()
    userIp = info.ip
  }
  data["userIp"] = userIp
  const url = `${SERVER_URL}/api/v1/auth/login/codestep1`;
  return axios.post(url, data);
};

const loginCodeStep2Api = (data) => {
  data["device"]="web"
  const url = `${SERVER_URL}/api/v1/auth/login/codestep2`;
  return axios.post(url, data);
};

const getAuthUserinfoApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/auth/register/userinfo`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await getAuthUserinfoApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const changeInvalidPhonenumberApi = async (data) => {
  try {
    let phoneCode = data["phoneNumber"].slice(0, 2)
    let userIp = null
    if (phoneCode !== "98") {
      let getIpUser = await fetch('https://api.ipify.org?format=json')
      let info = await getIpUser.json()
      userIp = info.ip
    }
    data["userIp"] = userIp
    const url = `${SERVER_URL}/api/v1/auth/register/changeInvalidPhonenumber`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await changeInvalidPhonenumberApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const ChangeUserNameApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/auth/register/changeusername`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await ChangeUserNameApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const checkUsernameValidApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/auth/register/checkusernamevalid`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await checkUsernameValidApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const getfreetrialApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/auth/register/getfreetrial`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await getfreetrialApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const addgmailApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/auth/register/addgmail`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await addgmailApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const requestoauthApi = async (data) => {
  data["device"]="web"
  const url = `${SERVER_URL}/api/v1/auth/register/requestoauth`;
  return axios.post(url, data);
};

const getregistertokenApi = async (data) => {
  try {
    data["device"]="web"
    const url = `${SERVER_URL}/api/v1/auth/login/getregistertoken`;
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${data["rtoken"]}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      console.error("jwt expired", error)

      let sucsess = await handleJWT();
      if (sucsess) {
        return await getregistertokenApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      console.error("jwt malformed", error)
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("token");
      window.location.href = "/";
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      console.error("jwt signature", error)
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("token");
      window.location.href = "/";
    } else {
      console.error(error)
      throw error
    }
  }
};


const getfreetrialallApi = async (data) => {
  try {
    const url = `${SERVER_URL}/api/v1/auth/register/getfreetrialall`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, data, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await getfreetrialallApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const getforumtokenApi = async () => {
  try {
    const url = `https://umlang.com/auth/api/v1/auth/login/getforumtoken`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, {}, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await getforumtokenApi({})
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};

const removeforumtokenApi = async () => {
  try {
    const url = `${SERVER_URL}/api/v1/auth/login/removeforumtoken`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.post(url, {}, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await removeforumtokenApi({})
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};


export {
  loginApi,
  RegisterStepOneApi,
  RegisterStepTwoApi,
  setPasswordApi,
  setReferralCodeApi,
  loginCodeStep1Api,
  loginCodeStep2Api,
  getAuthUserinfoApi,
  checkUsernameValidApi,
  ChangeUserNameApi,
  changePasswordApi,
  getfreetrialApi,
  requestoauthApi,
  getregistertokenApi,
  addgmailApi,
  changeInvalidPhonenumberApi,
  getfreetrialallApi,
  getforumtokenApi,
  removeforumtokenApi
};
